import { Routes } from '@angular/router';
import { OfflineResolver } from '@softline/application';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { SOFTLINE_PERMISSION_TRANSPORTAUFTRAG } from './transport.permissions';

export const energietransportRoutes: Routes = [
  {
    path: 'energietransport',
    loadComponent: () =>
      import('./pages/transport.component').then((o) => o.TransportComponent),
    children: [
      {
        path: ':id/station/:stationId',
        loadComponent: () =>
          import('./pages/station-detail/station-detail.component').then(
            (o) => o.StationDetailComponent
          ),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/auftrag-detail/auftrag-detail.component').then(
            (o) => o.AuftragDetailComponent
          ),
      },
      {
        path: '',
        loadComponent: () =>
          import('./pages/transport-list/transport-list.component').then(
            (o) => o.TransportListComponent
          ),
        pathMatch: 'full',
      },
      { path: '**', redirectTo: '/energietransport' },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_TRANSPORTAUFTRAG },
    resolve: { offlineReady: OfflineResolver },
  },
];
